import React from "react";

export const SetLeftSideMenuOpen = React.createContext((_: boolean) => {});
export const LeftSideMenuOpen = React.createContext(false);
export const SetFooterVisible = React.createContext((_: boolean) => {});
export const LeftSideMenuBottomPanel = React.createContext<React.MutableRefObject<HTMLDivElement | null> | null>(null);
export const BottomRightSideRefPanel = React.createContext<React.MutableRefObject<HTMLDivElement | null> | null>(null);
